import React from 'react';
import HeroComponent from "./HeroComponent"
import ViewProductsPage from "./ProductGrid"

// Error Boundary Component
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h2>
            <button 
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const ProductPage = () => (
  <ErrorBoundary>
    <div>
      <HeroComponent/>
      <ViewProductsPage/>
    </div>
  </ErrorBoundary>
);

export default ProductPage
